var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLumienBranco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 523.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m63.01,370.22c32.46,0,58.78.42,58.78.94s-26.32.94-58.78.94-58.78-.42-58.78-.94,26.32-.94,58.78-.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m436.54,370.22c32.46,0,58.78.42,58.78.94s-26.32.94-58.78.94-58.78-.42-58.78-.94,26.32-.94,58.78-.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m179.33,391.74c-3.76,3.06-8.76,4.73-14.8,4.73-10.59,0-16.64-6.83-19.52-10.16l4.99-5.69c3.06,4.12,8.76,8.67,15.32,8.67s11.82-3.76,11.82-10.16-6.74-8.76-9.81-9.98c-3.15-1.22-7.35-2.89-9.63-4.03-1.31-.61-3.85-1.93-6.04-4.29-2.19-2.28-3.94-5.6-3.94-10.51s2.28-8.93,5.52-11.64c3.33-2.8,8.06-4.47,13.92-4.47,9.89,0,15.67,6.04,17.34,7.79l-4.47,5.78c-2.98-3.15-7.35-6.48-13.31-6.48s-10.51,2.8-10.51,8.4,4.11,7.7,7.79,9.19l11.12,4.64c1.14.53,4.81,2.54,6.83,4.9,1.93,2.36,3.68,5.6,3.68,10.16,0,5.25-2.36,9.89-6.3,13.13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 195.44,
    y: 335,
    width: 8.49,
    height: 60.41
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "250.78 342.09 225.74 342.09 225.74 362.23 249.29 362.23 249.29 369.32 225.74 369.32 225.74 395.41 217.24 395.41 217.24 335 250.78 335 250.78 342.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m306.72,395.41h-9.46l-6.22-15.76h-25.92l-6.22,15.76h-8.93l24.6-60.59h7.44l24.69,60.59Zm-18.04-22.85l-10.59-27.14-10.59,27.14h21.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "342.09 342.09 325.11 342.09 325.11 395.41 316.62 395.41 316.62 342.09 299.54 342.09 299.54 335 342.09 335 342.09 342.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "51.61 521.3 0 521.3 0 416.57 14.72 416.57 14.72 508.7 51.61 508.7 51.61 521.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m140.56,478.5c0,13.05-1.21,23.38-8.35,31.88-7.13,8.2-17.61,12.75-31.42,12.75s-24.44-4.55-31.42-12.75c-7.29-8.5-8.5-18.82-8.5-31.88v-61.93h14.88v60.57c0,8.8.15,17.3,4.86,23.53,4.25,5.77,11.08,9.26,20.19,9.26s15.79-3.49,20.19-9.26c4.71-6.22,4.86-14.88,4.86-23.53v-60.57h14.72v61.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "274.14 521.3 259.56 521.3 252.73 438.57 252.28 438.57 220.25 522.21 211.9 522.21 179.87 438.57 179.42 438.57 172.74 521.3 158.17 521.3 167.58 416.57 185.79 416.57 216 497.47 216.3 497.47 246.51 416.57 264.57 416.57 274.14 521.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 292.5,
    y: 416.57,
    width: 14.72,
    height: 104.74
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "392.84 521.3 330.3 521.3 330.3 416.57 391.62 416.57 391.62 428.86 345.02 428.86 345.02 460.13 389.04 460.13 389.04 472.42 345.02 472.42 345.02 508.85 392.84 508.85 392.84 521.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m500,521.3h-14.42l-60.41-83.48s.3,14.12.3,27.78v55.71h-14.57v-104.74h15.48l59.35,82.27s-.15-12.9-.15-26.71v-55.56h14.42v104.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.31,
    width: 123.84,
    height: 282.96
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "379.01 152.32 379.01 282.96 249.71 282.96 379.01 152.32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLumienBranco);
export default __webpack_public_path__ + "static/media/Lumien - Branco.e50374342b77b46fae4164535649f16f.svg";
export { ForwardRef as ReactComponent };